module.exports = __webpack_public_path__ + "img/DandL.916658c5.png";